import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { Reveal, SectionIntro } from "./Shared";
import { FAQS } from "../data/content";

export const Faq = () => {
  const [open, setOpen] = useState(0);
  return (
    <section className="section mist" id="faq">
      <div className="container narrow-wide">
        <SectionIntro
          eyebrow="Frequently asked questions"
          title="Answers before you ask."
          copy="The questions we hear most often, from founders, professionals, students and organizations."
        />
        <div className="faq-list" data-testid="faq-section">
          {FAQS.map((f, i) => (
            <Reveal key={f.q} delay={Math.min(i * 0.05, 0.25)}>
              <div className={`faq-item${open === i ? " open" : ""}`}>
                <button
                  className="faq-question"
                  onClick={() => setOpen(open === i ? -1 : i)}
                  aria-expanded={open === i}
                  data-testid={`faq-question-${i + 1}`}
                >
                  <span>{f.q}</span>
                  <ChevronDown size={18} />
                </button>
                <div className="faq-answer" data-testid={`faq-answer-${i + 1}`}>
                  <p>{f.a}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
